export enum ForumCategoria {
  GERAL = 'geral',
  DUVIDAS = 'duvidas',
  ELOGIOS = 'elogios',
  SUGESTOES = 'sugestoes',
  CRITICAS = 'criticas',
}

export const ForumCategoriaLabels: Record<ForumCategoria, string> = {
  [ForumCategoria.GERAL]: 'Geral',
  [ForumCategoria.DUVIDAS]: 'Dúvidas',
  [ForumCategoria.ELOGIOS]: 'Elogios',
  [ForumCategoria.SUGESTOES]: 'Sugestões',
  [ForumCategoria.CRITICAS]: 'Críticas',
};

export const ForumCategoriaColors: Record<ForumCategoria, string> = {
  [ForumCategoria.GERAL]: 'bg-gray-500',
  [ForumCategoria.DUVIDAS]: 'bg-blue-500',
  [ForumCategoria.ELOGIOS]: 'bg-green-500',
  [ForumCategoria.SUGESTOES]: 'bg-yellow-500',
  [ForumCategoria.CRITICAS]: 'bg-red-500',
};

export interface ForumMilitar {
  id: string;
  nick: string;
  patente?: {
    id: string;
    patente: string;
  };
}

export interface ForumLike {
  id: string;
  militar_id: string;
  post_id?: string;
  comentario_id?: string;
  criado_em: string;
  militar?: ForumMilitar;
}

export interface ForumComentario {
  id: string;
  post_id: string;
  conteudo: string;
  militar_id: string;
  comentario_pai_id?: string;
  ativo: boolean;
  criado_em: string;
  atualizado_em: string;
  militar: ForumMilitar;
  respostas?: ForumComentario[];
  likes?: ForumLike[];
  likes_count?: number;
  user_liked?: boolean;
}

export interface ForumPost {
  id: string;
  titulo?: string;
  conteudo: string;
  categoria: ForumCategoria;
  militar_id: string;
  ativo: boolean;
  criado_em: string;
  atualizado_em: string;
  militar: ForumMilitar;
  comentarios?: ForumComentario[];
  likes?: ForumLike[];
  comentarios_count?: number;
  likes_count?: number;
  user_liked?: boolean;
}

export interface CreateForumPostData {
  conteudo: string;
  categoria: ForumCategoria;
}

export interface UpdateForumPostData {
  titulo?: string;
  conteudo?: string;
  categoria?: ForumCategoria;
}

export interface CreateForumComentarioData {
  conteudo: string;
}

export interface ForumPostFilters {
  categoria?: ForumCategoria;
  search?: string;
  orderBy?: 'recentes' | 'mais_comentados' | 'mais_curtidos';
  page?: number;
  limit?: number;
}

export interface ForumPostsResponse {
  posts: ForumPost[];
  total: number;
  page: number;
  limit: number;
  hasMore: boolean;
}
